import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSession } from './auth/SessionContext.jsx';

// Pages - filled in by Frontend Agents C and D
import Login from './pages/Login.jsx';
import Home from './pages/Home.jsx';
import Capture from './pages/Capture.jsx';
import MapView from './pages/Map.jsx';
import ListView from './pages/List.jsx';
import AvaloirDetail from './pages/AvaloirDetail.jsx';
import AdminCodes from './pages/AdminCodes.jsx';
import AdminSurvey from './pages/AdminSurvey.jsx';
import AdminStats from './pages/AdminStats.jsx';
import AdminGestion from './pages/AdminGestion.jsx';
import AdminGestionMap from './pages/AdminGestionMap.jsx';
import ZoneSensible from './pages/ZoneSensible.jsx';

function Protected({ children, adminOnly = false }) {
  const { session, loading } = useSession();
  const loc = useLocation();
  if (loading) return null;
  if (!session) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (adminOnly && session.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Home /></Protected>} />
      <Route path="/capture" element={<Protected><Capture /></Protected>} />
      <Route path="/zone-sensible" element={<Protected><ZoneSensible /></Protected>} />
      <Route path="/map" element={<Protected><MapView /></Protected>} />
      <Route path="/list" element={<Protected><ListView /></Protected>} />
      <Route path="/avaloir/:id" element={<Protected><AvaloirDetail /></Protected>} />
      <Route path="/admin/codes" element={<Protected adminOnly><AdminCodes /></Protected>} />
      <Route path="/admin/survey" element={<Protected adminOnly><AdminSurvey /></Protected>} />
      <Route path="/admin/stats" element={<Protected adminOnly><AdminStats /></Protected>} />
      <Route path="/admin/gestion" element={<Protected adminOnly><AdminGestion /></Protected>} />
      <Route path="/admin/gestion/carte" element={<Protected adminOnly><AdminGestionMap /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
